// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"link-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.2934 18.3638L9.87923 19.778C8.12187 21.5354 5.27259 21.5353 3.51527 19.778C1.75795 18.0207 1.75791 15.1714 3.51527 13.414L6.69725 10.2321C8.45461 8.47471 11.3039 8.47475 13.0612 10.2321L13.65 10.8208M12.7075 5.63652L14.1217 4.2223C15.879 2.46494 18.7283 2.46498 20.4856 4.2223C22.243 5.97963 22.243 8.8289 20.4856 10.5863L17.3037 13.7682C15.5463 15.5256 12.697 15.5256 10.9397 13.7682L10.1143 12.9428","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Link1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'link-1',
    ref,
    icon: element,
  },
));

Link1Icon.displayName = 'Link1Icon';

export default Link1Icon;
